export const SET_REPORTS_FILTER = 'setReportsFilter';

export default {
  state: {
    filters: {
      search: '',
      dateFrom: null,
      dateTo: null,
      status: null,
      projectManager: null,
      useAdvancedSearch: false,
      advancedSearch: null,
    },
  },
  mutations: {
    [SET_REPORTS_FILTER](state, payload) {
      const filters = {
        ...state.filters,
        ...payload,
      };

      state.filters = filters?.status?.some(
        (entry) => typeof entry === 'string',
      )
        ? { ...filters, status: [] }
        : filters;
    },
  },
};
